module.exports = __webpack_public_path__ + "static/img/5.8fc3022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v14_new_features/5.png
// module id = bCU0
// module chunks = 0